import React from "react";
import styled from "styled-components";
import Content from "./components/Content";
import Header from "./components/Header";
import { DiscussionEmbed } from "disqus-react";
import KakaoAd from "./components/KakaoAd";
import { useKakaoScript } from "react-kakao-share";
import ReactGA from "react-ga4";

const gaTrackingId = "G-GQ84HMFHL9";
ReactGA.initialize(gaTrackingId);
ReactGA.send("pageview");

function App() {
  useKakaoScript();

  return (
    <Wrapper>
      <LeftKakaoAd adUnit="DAN-0QSpmEDAR514n3pV" adWidth="160" adHeight="600" />
      <RightKakaoAd
        adUnit="DAN-XCbwqXVSejB1cEpt"
        adWidth="160"
        adHeight="600"
      />

      <Container>
        <CaptureDiv id="digimon-container">
          <Header />
          <Content />
        </CaptureDiv>
        <KakaoAd adUnit="DAN-sXQToYRVdaAqEML2" adWidth="320" adHeight="100" />
        <br />
        <KakaoAd adUnit="DAN-FFqXYXA35yilTuGl" adWidth="320" adHeight="100" />

        <DiscussContainer>
          <DiscussionEmbed
            shortname="daehwan2-digimon-face"
            config={{
              url: `https://daehwan2-digimon-face.disqus.com/embed.js`,
              identifier: "digimon-face",
              title: "digimon-face",
              language: "ko", //e.g. for Traditional Chinese (Taiwan)
            }}
          />
        </DiscussContainer>
      </Container>
      {/* <KakaoAd adUnit="DAN-wguLjUjzmSz5jNVO" adWidth="300" adHeight="250" /> */}
    </Wrapper>
  );
}

export default App;

const Container = styled.div`
  max-width: 700px;
  margin: auto;
  background-color: ${({ theme }) => theme.color.background};

  padding: 0 8px;
`;
const CaptureDiv = styled.div`
  background-color: ${({ theme }) => theme.color.background};
`;

const DiscussContainer = styled.div`
  background-color: #fff;

  padding: 10px;

  border-radius: 8px;

  margin-top: 30px;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const LeftKakaoAd = styled(KakaoAd)`
  position: absolute;
  top: 0;
  left: 0;

  width: auto;

  @media (max-width: 1020px) {
    display: none;
  }
`;

const RightKakaoAd = styled(KakaoAd)`
  position: absolute;
  top: 0;
  right: 0;

  width: auto;

  @media (max-width: 1020px) {
    display: none;
  }
`;
